import { render, staticRenderFns } from "./FormTags.vue?vue&type=template&id=4b1cb9d2"
import script from "./FormTags.vue?vue&type=script&lang=js"
export * from "./FormTags.vue?vue&type=script&lang=js"
import style0 from "./FormTags.vue?vue&type=style&index=0&id=4b1cb9d2&prod&lang=css"
import style1 from "./FormTags.vue?vue&type=style&index=1&id=4b1cb9d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports